import moment from "moment";
import { useEffect, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useSelector } from "react-redux";

import { AppState } from "shared/data/reducers/index";
import { dayMonthFormat } from "shared/lib/datetime";
import { formattedMessageParams } from "shared/messages";

import useSearchInfo from "../useSearchInfo";

const { priceLabel } = defineMessages({
  priceLabel: formattedMessageParams("ShareModal.price"),
});

export type ReturnTypes = {
  url: string;
  title: string;
  aditionalInfo: string;
};

const useShareInfo = (): ReturnTypes => {
  const intl = useIntl();
  const [windowHref, setWindowHref] = useState("");

  useEffect(() => {
    setWindowHref(window.location.href);
  }, []);

  const { price, currency, defaultCountry } = useSelector(
    (appState: AppState) => ({
      price: appState.price,
      currency: appState.requestorConfig.currency,
      defaultCountry:
        appState.storage.frontendSettings?.dealerFrontendSettings
          ?.defaultCountry ?? "",
    })
  );

  const currencySymbol = currency === "CZK" ? "Kč" : currency;

  const searchInfo = useSearchInfo();

  const fullPrice = `${intl.formatMessage(priceLabel)} ${Number(
    price?.fullPrice
  ).toFixed(0)} ${currencySymbol}`;

  const aditionalInfo = `${searchInfo.travelFrom} - ${
    searchInfo.travelTo
  }, ${moment(searchInfo.departureDate).format(
    dayMonthFormat(defaultCountry)
  )}, ${fullPrice}`;

  return {
    url: windowHref,
    title: aditionalInfo,
    aditionalInfo,
  };
};

export default useShareInfo;
